/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth, borderRadius } = borders;

export default {
  styleOverrides: {
    root: ({ theme }) => {
      const mode = theme.palette.mode || "light";
      const { inputColors, text, background } = colors[mode];

      return {
        display: "flex !important",
        padding: `${pxToRem(8)} ${pxToRem(28)} ${pxToRem(8)} ${pxToRem(12)} !important`,
        border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
        borderRadius: `${borderRadius.md} !important`,
        backgroundColor: background.paper,
        color: text.primary,
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",

        "&:hover": {
          borderColor: inputColors.borderColor.focus,
        },

        "&.Mui-focused": {
          borderColor: inputColors.borderColor.focus,
          boxShadow: `0 0 0 2px ${inputColors.boxShadow}40`,
        },

        "& fieldset": {
          border: "none",
        },

        "& input": {
          color: text.primary,
        },

        "& input::placeholder": {
          color: text.disabled,
          opacity: 1,
        },
      };
    },

    input: {
      height: pxToRem(22),
      width: "max-content !important",
    },

    inputSizeSmall: {
      height: pxToRem(14),
    },
  },
};
